import { mkhctokenEventType } from "./dispatchSignInInfoEvent";
import { SignInInfo } from "./normalizeSigninResponse";

export function getSignInInfo(): SignInInfo | "initial" {
  const stringValue = sessionStorage.getItem(mkhctokenEventType);

  if (stringValue === null) {
    return "initial";
  } else {
    const objectValue = JSON.parse(stringValue) as SignInInfo;
    return {
      ...objectValue,
      expiresAt: new Date(objectValue.expiresAt),
      refreshTokenExpiresAt: new Date(objectValue.refreshTokenExpiresAt),
    };
  }
}
